import {Tooltip} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import {Refresh, Visibility} from "@material-ui/icons";
import Delete from "@material-ui/icons/Delete";
import React from "react";

export default function TableActions({openDeleteDialog, openStatusChangeDialog, openViewDialog, isSelected}) {
    return (
        <>
            <Tooltip title="View Token">
                <IconButton aria-label="view" className="agreement-table-action">
                    <Box
                        component={Visibility}
                        width="1.25rem!important"
                        height="1.25rem!important"
                        style={{fill:isSelected?"#0b456e":""}}
                        onClick={openViewDialog}
                    />
                </IconButton>
            </Tooltip>
            <Tooltip title="Regenerate Token">
                <IconButton aria-label="edit" className="agreement-table-action">
                    <Box
                        component={Refresh}
                        width="1.25rem!important"
                        height="1.25rem!important"
                        onClick={openStatusChangeDialog}
                    />
                </IconButton>
            </Tooltip>
            <Tooltip title="Delete Token">
                <IconButton aria-label="delete" className="agreement-table-action">
                    <Box
                        component={Delete}
                        width="1.25rem!important"
                        height="1.25rem!important"
                        onClick={openDeleteDialog}
                    />
                </IconButton>
            </Tooltip>
        </>
    );
};
